import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[appAsideContent]',
})
export class AsideContentDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
